export function matrixRoutingModel(data) {
    if (data.error) {
        return { error: data.error };
    }
    if (data.matrix) {
        return data;
    }
    return null;
}
